import { computed, inject } from '@angular/core';

import { AlertsFacade } from '../../alerts/facades/alerts.facade';
import { injectFromStore } from '../../shared/store/selectors/injectFromStore';
import { getUserEnvLoadingState } from '../../shared/store/selectors/user-env';
import { getSites } from '../../site-list/store/selectors/sites';
import { FavoriteOID } from '../models/favorite';
import { FavoriteSiteService } from '../store/api/favorite-site.service';
import { getFavorites } from '../store/selectors/favorite-site';
import { buildFavoriteSites } from '../utils/build-favorite-sites';

export function useFavorites() {
    const favoriteSiteService = inject(FavoriteSiteService);
    const alertsFacade = inject(AlertsFacade);

    const favorites = injectFromStore(getFavorites);
    const availableSitesById = injectFromStore(getSites);
    const userEnvironmentLoading = injectFromStore(getUserEnvLoadingState);
    const vm = computed(() => ({
        favoriteSites: buildFavoriteSites(favorites() ?? [], availableSitesById() ?? {}, alertsFacade.pendingAlerts()),
        loading: userEnvironmentLoading(),
    }));

    const removeFavorite = (favoriteOID: FavoriteOID) => {
        favoriteSiteService.removeFavorite(favoriteOID).subscribe();
    };

    return { vm, removeFavorite };
}
